import { registerFeatureMessages, type SupportedLocale } from '@/shared/i18n'

/**
 * Merges `features/commerce-analytics/i18n/<locale>.json` under the `commerceAnalytics` namespace
 * (contract 27 §13). The argument is the NAMESPACE, not the folder — the loader derives
 * `commerce-analytics/` from it and merges the tree under the camelCase key. English only:
 * ORP-19869 deleted the Turkish catalogs on purpose, so there is no `tr.json`.
 */
export function registerCommerceMessages(locale: SupportedLocale): Promise<void> {
  return registerFeatureMessages('commerceAnalytics', locale)
}
